import { useState, useEffect, useCallback } from 'react';

import styles from './stylesTableTabs.module.css';

function TableTabs({ onSelectTab }) {
  const [activeTab, setActiveTab] = useState();

  const handleTabClick = useCallback(
    (id) => {
      setActiveTab(id);
      onSelectTab(id);
    },
    [onSelectTab]
  );

  useEffect(() => {
    handleTabClick('PENDING');
  }, [handleTabClick]);

  return (
    <div className={styles.tableTabs}>
      <div
        onClick={() => handleTabClick('PENDING')}
        className={`${styles.tableTab} ${
          activeTab === 'PENDING' ? styles.active : ''
        }`}
      >
        <span>Pending Requests</span>
      </div>
      <div
        onClick={() => handleTabClick('PROCESSED')}
        className={`${styles.tableTab} ${
          activeTab === 'PROCESSED' ? styles.active : ''
        }`}
      >
        <span>Processed Requests</span>
      </div>
    </div>
  );
}

export default TableTabs;
